import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box } from "@mui/material";
// import bromma from "../../../Images/clientLogo/bromma.png"
// import mshe from "../../../Images/clientLogo/logo_mshe.png"
// import ananocoat from "../../../Images/clientLogo/ananocoat.png"
// import malaysiaAirline from "../../../Images/clientLogo/malaysiaAirline.jpeg"
// import malaysiaAirport from "../../../Images/clientLogo/malaysiaAirport.png"
// import KKP from "../../../Images/clientLogo/KKP_FA.png"
// import osharigato from "../../../Images/clientLogo/osharigato.png"
// import NGK from "../../../Images/clientLogo/NGK.png" 
// import pride from "../../../Images/clientLogo/pride.png"
import "./autoslider.css"

const images = [
  "/Images/clientLogo/logo_mshe.png",
  "/Images/clientLogo/bromma.png",
  "/Images/clientLogo/ananocoat.png",
  "/Images/clientLogo/pride.png",
  "/Images/clientLogo/malaysiaAirline.jpeg",
  "/Images/clientLogo/NGK.png",
  "/Images/clientLogo/malaysiaAirport.png",
  "/Images/clientLogo/KKP_FA.png",
  "/Images/clientLogo/osharigato.png",
];



const AutoSlider = () => {
    const settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 6,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: true,
      autoplaySpeed: 3000, // Change slide every 3 seconds
      arrows: false, // Hide arrows if not needed'
      className: "myCustomCarousel",
      responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows:true
            //   infinite: true,
            //   dots: true
            }
          },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows:true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true
        }
      }
    ]
    };
  
    return (
      <Box sx={{ maxWidth: "80%", margin: "auto", mt: 5 }}>
        <Slider {...settings}>
          {images.map((img, index) => (
            <Box key={index} sx={{ px: 4 }}>  
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              style={{ width: "100%", height:"90px"  }}
            />
          </Box>
          ))}
        </Slider>
      </Box>
    );
  };



export default AutoSlider;
